import { LoadingView } from "@/features/Auth/components/LoadingView";
import { useResourceById } from "@/features/Resources/hooks/useResources";
import { useWorkspaceById } from "@/features/Workspaces/hooks/useWorkspaces";
import { Navigate, useParams } from "react-router-dom";

interface RedirectIfAuthenticatedRouteProps {
  children: JSX.Element;
  to: string;
  loadingView?: JSX.Element;
}

/**
 * a route that redirects the user if they are authenticated
 */
export const RedirectIfMissingAccess = ({
  children,
  to,
  loadingView = <LoadingView />,
}: RedirectIfAuthenticatedRouteProps) => {
  const { promptbookId } = useParams();
  const { data: promptbook, isError, isLoading } = useResourceById(promptbookId!);
  const { isError: isWorkspaceError, isLoading: isLoadingWorkspace } = useWorkspaceById(
    promptbook?.workspace_id || undefined,
  );

  if (isError || isWorkspaceError) {
    return <Navigate to="/error" replace />;
  }

  if (isLoading || isLoadingWorkspace) {
    return loadingView;
  }

  if (!promptbook && !isLoading) {
    return <Navigate to={to} replace />;
  }

  return children;
};
